import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedView } from "@app/theme";
import { ThemedText } from "@app/theme/Components";
import HeadSnapshot from "../../../assets/Icons/HeadSnapshot";
import { ScrollView } from "react-native";
import { formatIndianCurrency } from "@app/utils/utility";
import Rupee from "../../../assets/Icons/Rupee";
import WorkAlert from "../../../assets/Icons/WorkAlert";

const InterestLearnMore = ({navigation,route})=>{
    const {outstandingInterest,isFromTata,isLenderBajaj} = route.params;
    return(
        <>
        <PageHeaders pageName={route?.name} navigation={navigation}/>
        <ScrollView style={{flex:1, backgroundColor:themeColorSet["bg-surface-primary"],padding:16}}>
            <ThemedText color="text-primary" variant="h4s" mb="5xl">
                What happens if your account is overdue?
            </ThemedText>
            <ThemedView flexDirection="row">
                <ThemedView mt="xs" backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                    <HeadSnapshot />
                </ThemedView>
                <ThemedView ml="md"  flex={1} flexWrap="wrap">
                    <ThemedText color="text-primary" variant="b3m">
                    Penal interest {isLenderBajaj ? '@24%': '@36%'} pa on ₹{formatIndianCurrency(outstandingInterest)}
                    </ThemedText>
                    <ThemedText color="text-secondary" variant="b4r">
                    Penal interest will be applied on amount overdue from { isFromTata?'4th':'7th'} of the month till payment date
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-primary" my="lg" width={'100%'} />
            <ThemedView flexDirection="row" >
                <ThemedView mt="xs" backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                    <WorkAlert />
                </ThemedView>
                <ThemedView ml="md"  flex={1} flexWrap="wrap">
                    <ThemedText color="text-primary" variant="b3m">
                    Portfolio sell-off to recover overdue amount
                    </ThemedText>
                    <ThemedText color="text-secondary" variant="b4r">
                    If payment is not done by {isFromTata?'4th':'14th'} of the month, portfolio sell-off will be done to recover overdue amount
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-primary" my="lg" width={'100%'} />
            <ThemedView flexDirection="row">
                <ThemedView mt="xs" backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                    <Rupee />
                </ThemedView>
                <ThemedView ml="md"  flex={1} flexWrap="wrap">
                    <ThemedText color="text-primary" variant="b3m">
                    Impact on credit score
                    </ThemedText>
                    <ThemedText color="text-secondary" variant="b4r">
                    Not making payments on time can affect your credit score
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        </ScrollView>   
        <ThemedView backgroundColor="bg-surface-primary" p="lg" borderTopWidth={1} borderTopColor="border-primary">
            <Button label="Ok, got it!" handlePress={()=>navigation?.goBack()} />
        </ThemedView>
        </>
    )
}

export default InterestLearnMore;